import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register GSAP plugin
gsap.registerPlugin(ScrollTrigger);

export default class ScrollSection {
  constructor(section) {
    if (section) {
      this.section = section;
      this.slides = section.querySelectorAll('.slide');
      this.currentMode = null; // 'mobile' or 'desktop'
      this.init();
      this.setupResizeListener();
    }
  }

  init() {
    this.setupScrollTrigger();
  }

  setupScrollTrigger() {
    const isMobile = window.innerWidth < 992;
    const mode = isMobile ? 'mobile' : 'desktop';

    if (this.currentMode === mode) return; // Avoid re-initializing for the same mode

    this.cleanup(); // Clear old ScrollTriggers

    this.currentMode = mode;

    if (isMobile) {
      return;
    }

    // Highlight active menu item based on scroll
    this.slides.forEach((slide) => {
      ScrollTrigger.create({
        trigger: slide,
        start: 'top top',
        end: 'bottom bottom',
      });
    });

    // Slide movement and pinning
    this.scrollTween = gsap.to(this.section.querySelector('.slides'), {
      yPercent: -100 * (this.slides.length - 1),
      ease: 'none',
      scrollTrigger: {
        trigger: this.section,
        start: 'top top',
        end: () => `+=${window.innerHeight * this.slides.length}`,
        scrub: true,
        pin: true,
      },
    });
  }

  cleanup() {
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    if (this.scrollTween) {
      this.scrollTween.kill();
      this.scrollTween = null;
    }
  }

  setupResizeListener() {
    window.addEventListener('resize', () => {
      this.setupScrollTrigger();
    });
  }
}
